import axios from "axios"
import config from '../utils/config';
import {
  mapGetters,
  mapState
} from "vuex";
export default getCategory = {
  data() {
    return {
      address: {},
      places: "",
      search: [],
      loading: false,
      options: {
        fields: ["address_components", "geometry", "icon", "adr_address"],
        componentRestrictions: { country: ["NZ", "AU"] },
      },
      lat: 0,
      lng: 0,
      filterOpen: false,
    }
  },
  methods: {
    setfilterOpen() {
      const mainWrap = document.getElementById("mainContent")
      const searchWrap = document.getElementById("navSearch")
      const mapBtn = document.getElementById("mapBtn")
      if (this.filterOpen) {
        this.filterOpen = false
        mainWrap.style.zIndex = 0
        mainWrap.style.position = "static"
        searchWrap.style.zIndex = 1
        document.documentElement.style.overflowY = "auto"
        document.body.style.overflowY = "auto"
        mapBtn.classList.remove("d-none")
      } else {
        this.filterOpen = true
        mainWrap.style.position = "relative"
        mainWrap.style.zIndex = 9
        searchWrap.style.zIndex = 9
        document.documentElement.style.overflowY = "hidden"
        document.body.style.overflowY = "hidden"
        mapBtn.classList.add("d-none")
      }
    },
    searchAuto() {
      const autocomplete = new google.maps.places.Autocomplete(
        this.$refs["search"],
        this.options
      )
      autocomplete.addListener("place_changed", () => {
        this.places = autocomplete.getPlace()
        this.lat = this.places.geometry.location.lat()
        this.lng = this.places.geometry.location.lng()
        this.$refs["info"].innerHTML = this.places.adr_address
        this.search = this.places.address_components.map(
          (item) => item.short_name
        )

        this.loading = true
        this.getCat()     
      })
    },
    async getCat() {
      const configs = config
      config.headers["NETOAPI_ACTION"] = "GetCategory"
      const resCat = await axios.post(
        "https://www.skyepics.com.au/do/WS/NetoAPI",
        {
          Filter: {
            CategoryName: this.search,
            OutputSelector: [
              "CategoryID",
              "ShortDescription1",
              "ShortDescription2",
              "ShortDescription3",
            ],
            Active: true,
          },
        },
        config
      )
      const cats = resCat.data.Category

      this.checkCategory(cats)
    },
    checkCategory(cats) {
      const locInfo = this.$refs["info"]
      const streetAdressHtml = locInfo.querySelector(".street-address")
      this.address.streetAdress = streetAdressHtml
        ? streetAdressHtml.innerText
        : false
      const streetAdress = this.address.streetAdress
        ? `&${encodeURI(this.$refs["search"].value)}`
        : `&false`

      const strings = this.search.map((item) => {
        return item.toLowerCase().replaceAll(" ", "-")
      })
      const filterdCats = cats
        .map((item) => {
          let count = 0
          strings.forEach((el) => {
            if (item.ShortDescription1.includes(el)) {
              count++
            }
          })
          return {
            url: item.ShortDescription1,
            count: count,
          }
        })
        .sort((a, b) => a.count - b.count)
      localStorage.removeItem('selected');
      if (filterdCats.length !== 0) {
        window.location.href = `${window.location.origin}${
          filterdCats[filterdCats.length - 1].url
        }?&${this.lat},${this.lng}${streetAdress}`
      } else {
        this.loading = false
      }
    },
  },
  computed: {
    ...mapGetters("products", ["selected"]),    
    ...mapState("products", ["street"]),
    // streetName(){
    //   return this.street ? this.street : window.catName
    // }
},
  mounted() {
    this.searchAuto()
  },
}
